unable to read source [project]/packages/src/assets/IconNames.tsx